import axios from 'axios';

import { buildLabelPayload } from '@features/event-level-column-rename/utils/build-label-payload';
import type { EventSettableColumnId } from '@features/event-level-column-rename/types';
import type { ID } from 'types';

export interface UpdateLineItemColumnLabelsParams {
  eventId: ID;
  values: Partial<Record<EventSettableColumnId, string>>;
}

/**
 * TRANSPORT (Building Code "Golden Path"): a plain async function that reaches the endpoint and
 * returns a promise — no React, no TanStack, no hooks — so it stays unit-testable without a
 * QueryClient. What a write causes afterwards (refresh, toast) lives in `actions.ts`.
 */
export const updateLineItemColumnLabels = async ({
  eventId,
  values,
}: UpdateLineItemColumnLabelsParams): Promise<void> => {
  await axios.patch(
    `/api/v1/events/${eventId}/line_item_column_labels`,
    buildLabelPayload(values)
  );
};
